import { ArrowDownOutlined } from '@ant-design/icons';
import { FileIcon } from '@marine/files';
import { List, Tag, Typography } from 'antd';
import { FC, useCallback } from 'react';
import { ComponentBoatsDocuments } from 'services/graphql/cms';
import styles from './BoatDocuments.module.scss';

export interface BoatDocumentsProps {
  documents?: ComponentBoatsDocuments[];
}

const BoatDocuments: FC<BoatDocumentsProps> = ({ documents }) => {
  const getFileType = useCallback(
    (fileUrl: string | undefined) => fileUrl?.split(/[#?]/)[0]?.split('.')?.pop()?.trim().toLowerCase(),
    [],
  );
  const getFileSize = useCallback((size?: number): string | undefined => {
    if (size) {
      return (size / 1000).toFixed(2) + 'MB';
    }
  }, []);

  return (
    <div className={styles.boatDocumentsWrapper}>
      <List
        bordered
        dataSource={documents}
        renderItem={(item) => (
          <List.Item>
            <div className={styles.item}>
              <FileIcon ext={getFileType(item.file.url)} />
              <div className={styles.content}>
                <div className={styles.text}>
                  <Typography.Text>
                    <strong>{item.file.name}</strong>
                  </Typography.Text>
                  {Array.isArray(item.tags) && item.tags.length && (
                    <ul className={styles.tags}>
                      {item.tags.map((item) => (
                        <li key={item}>
                          <Tag color="geekblue">{item}</Tag>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className={styles.action}>
                  <span style={{ marginRight: 16 }}>{getFileSize(item.file.size)}</span>
                  {!!item.file.url && (
                    <a
                      href={item.file.url}
                      target="_blank"
                      rel="noreferrer"
                      download={item.file.url}
                      className="ant-btn ant-btn-default"
                    >
                      <ArrowDownOutlined /> Download
                    </a>
                  )}
                </div>
              </div>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export { BoatDocuments };
